export default defineNuxtRouteMiddleware((to, from) => {
  // 1. Grab our temporary bypass flag
  const skipPreserve = useState('skipPreserveQuery', () => false)

  // 2. If the flag is true, reset it and abort the preservation logic
  if (skipPreserve.value) {
    skipPreserve.value = false // Reset for future navigations
    return // Let Nuxt navigate normally (dropping the queries)
  }

  const hasNewQueries = Object.keys(to.query).length > 0
  const hasOldQueries = Object.keys(from.query).length > 0

  if (!hasNewQueries && hasOldQueries) {
    return navigateTo({
      ...to,
      query: from.query,
    })
  }
})

// Sample how to trigger the bypass in a component:
/*
const skipPreserve = useState('skipPreserveQuery')

const navigateWithoutQueries = async (path: string) => {
  skipPreserve.value = true // Tell the middleware to skip this one
  await navigateTo(path)
}
*/
